module.exports = __webpack_public_path__ + "static/img/skin_comfort.f5b864d2.png";